export const ANNUAL_LEAVE = 1;
export const SICK_LEAVE = 2;
export const MATERNITY_LEAVE = 3;
export const PATERNITY_LEAVE = 4;
export const MARRIAGE_LEAVE = 5;
export const BIRTHDAY_LEAVE = 6;
export const COMPASSIONATE_LEAVE = 7;
export const EXAMINATION_LEAVE = 8;
export const JURY_LEAVE = 9;
export const NO_PAY_LEAVE = 10;
export const COMPENSATION_LEAVE = 11;
export const OTHER_LEAVE = 12;
